module.exports = __webpack_public_path__ + "static/media/2.5305c7f7.png";